module.exports = __webpack_public_path__ + "img/Chart.9d4c0732.svg";